export class Autoclavable {
    id:number;
    value:string;
    count:number; 
}


// WEBPACK FOOTER //
// /Users/thomas.obrien2/projects/nalgene/src/app/categories/autoclavable.ts